<!--
 * @Author: WeiZisen
 * @Date: 2021-03-10 15:54:51
 * @LastEditors: pengmiaopei
 * @LastEditTime: 2021-09-02 11:09:27
 * @Description: 请输入一段描述
 * @FilePath: \Design_Vue_pmp\src\common\components\ProjectSelect\index.vue
-->
<template>
  <div>
    <vab-remix-icon icon="search-line" @click="click" />
  </div>
  <!-- v-if="theme.showFullScreen" -->
</template>

<script>
  export default {
    name: 'ProjectSelect',
    data() {
      return {
        isFullscreen: false,
      }
    },
    mounted() {},
    beforeDestroy() {},
    methods: {
      click() {
        //1、父组件可以使用 props 把数据传给子组件。(子组件可以使用 props 接收父组件的数据)
        //2、子组件可以使用 $emit 触发父组件的自定义事件。
        this.$emit('projectClick') //这里的父组件的方法2
      },
    },
  }
</script>
